<template>
    <SwitchGroup as="div" :class="{
        flex: true,
        'items-center': !description,
        'items-start': description,
    }">
        <!-- Label à direita -->
        <SwitchLabel v-if="orientation === 'right'" as="div" class="mr-auto flex flex-col">
            <div class="text-sm font-normal text-zinc-700 dark:text-zinc-300">
                {{ label }}
            </div>
            <div v-if="description" class="text-xs font-normal text-zinc-400 dark:text-zinc-500">
                {{ description }}
            </div>
        </SwitchLabel>

        <!-- Toggle -->
        <Switch :value="value" v-model="proxyChecked" @click="(e: Event) => disabled && e.preventDefault()" :class="[
            proxyChecked
                ? 'bg-violet-600'
                : 'bg-zinc-200 dark:bg-zinc-700',
            disabled
                ? 'opacity-50 cursor-not-allowed'
                : 'cursor-pointer',
            'relative inline-flex flex-shrink-0 h-5 w-9 border-2 border-transparent rounded-full transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-600',
        ]">
            <span aria-hidden="true" :class="[
                proxyChecked ? 'translate-x-4' : 'translate-x-0',
                'pointer-events-none inline-block h-4 w-4 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
            ]" />
        </Switch>

        <!-- Label à esquerda -->
        <SwitchLabel v-if="orientation === 'left'" as="div" class="ml-2 flex flex-col">
            <div class="text-sm font-normal text-zinc-700 dark:text-zinc-300">
                {{ label }}
            </div>
            <div v-if="description" class="text-xs font-normal text-zinc-400 dark:text-zinc-500">
                {{ description }}
            </div>
        </SwitchLabel>
    </SwitchGroup>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { Switch, SwitchGroup, SwitchLabel } from "@headlessui/vue";
import { useField } from "vee-validate";

const emit = defineEmits(["update:checked"]);

const props = defineProps({
    checked: {
        type: Boolean,
        default: false,
    },
    name: {
        type: String,
        required: false
    },
    id: {
        type: String,
        required: false
    },
    value: {
        type: String,
        default: "",
    },

    label: {
        default: "",
    },

    orientation: {
        default: "left",
        required: false,
    },

    description: {
        default: "",
    },

    disabled: {
        default: false,
        required: false,
    },
});

const { handleChange } = useField(props.name ?? '');

const proxyChecked = computed({
    get() {
        return props.checked;
    },
    set(val) {
        if (props.name) {
            handleChange(val);
        }
        else {
            emit("update:checked", val);
        }
    },
});
</script>